import { Button, Grid2 as Grid, Stack } from "@mui/material";

import {
  Form,
} from "@shared/components";

export function LoginIntegrationForm({
  onSubmit,
  isSubmitting,
}: {
  onSubmit: (data: any) => void;
  isSubmitting: boolean;
}) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="username"
          label={"Usuário"}
          type="username"
          required
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="password"
          label={"Senha"}
          type="'password"
          required
          fullWidth
        />
      </Grid>
      <Stack
        display={"flex"}
        justifyContent={"flex-end"}
        marginLeft="auto"
        spacing={1}
        mt={2}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          Testar Login
        </Button>
      </Stack>
    </Grid>
  );
}
